module.exports = __webpack_public_path__ + "static/media/download_share.a7920ff4.svg";